module.exports = __webpack_public_path__ + "img/download-icon.c9c4dcab.png";